import React from "react";
import { Button, Row, Col } from 'react-bootstrap'

class PersonList extends React.Component {
    constructor(props) {
        super(props);
        this.changeData = this.changeData.bind(this);
        this.state = {
            message: 'PersonList',
        };
    }

    changeData(data, fullName) {
        this.props.referenceCallback(data, fullName);
    }

    render() {
        return (
            <div className="px-4 main-detail">
                <Row className="blue-bg py-2">
                    <Col xs={2} md={2} className="text-center pr-0 gray-text3">เลขที่</Col>
                    <Col xs={6} md={6} className="text-center gray-text3">ชื่อ - นามสกุล</Col>
                    <Col xs={4} md={4} className="text-center px-0"></Col>
                </Row>
                {
                    (this.props.dataDetail.length > 0) ? (
                        this.props.dataDetail.map((item, index) => (
                            <Row key={index.toString()} className="border-bottom-blue  py-3">
                                <Col xs={2} md={2} className="text-center my-1"><h5 className="mb-0 font-weight-600">{item.student.no}</h5></Col>
                                <Col xs={6} md={6} className="text-left my-1">
                                    <h5 className="mb-0 font-weight-600">{item.student.fullName}</h5>
                                    <h6 className="gray-text3">เข้าร่วมกิจกรรม {item.totalActivity} ครั้ง</h6>
                                </Col>
                                <Col xs={4} md={4} className="text-right my-1">
                                    <Button className="bluesky d-inline py-1 py-1 py-lg-2 px-3 px-lg-5 bt font-sarabun-bold btn btn-primary m-auto" onClick={() => this.changeData(item.student.id, item.student.fullName)}><h5 className="mb-0 font-weight-bold">เลือก</h5></Button>
                                </Col>
                            </Row>
                        ))
                    ) : (
                        <div></div>
                    )
                }
            </div>
        )
    }
}

export default PersonList